export const ActionTypes = {
    GET_PEOPLE_BY_ID: "GET_PEOPLE_BY_ID",
    GET_PEOPLE_LIST:"GET_PEOPLE_LIST",
    SET_PEOPLE_ORDER:"SET_PEOPLE_ORDER",
    SET_SELECTED_VIEW:"SET_SELECTED_VIEW",
    GET_USER_LIST: "GET_USER_LIST",
    RESET_STATE: 'RESET_STATE'
};
